import * as React from 'react';
import { cn } from '@/lib/utils';

interface SettingsFormSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function SettingsFormSection({
  title,
  description,
  children,
  className,
}: SettingsFormSectionProps) {
  return (
    <div className={cn('space-y-4', className)}>
      <div>
        <h3 className="text-lg font-medium">{title}</h3>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>
      <div className="space-y-4">{children}</div>
    </div>
  );
}

interface SettingsFieldProps {
  label: string;
  htmlFor?: string;
  description?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
}

export function SettingsField({
  label,
  htmlFor,
  description,
  error,
  children,
  className,
}: SettingsFieldProps) {
  return (
    <div className={cn('grid gap-2', className)}>
      <div className="flex items-center justify-between">
        <label
          htmlFor={htmlFor}
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
        >
          {label}
        </label>
        {description && (
          <span className="text-xs text-muted-foreground">{description}</span>
        )}
      </div>
      {children}
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}

interface SettingsToggleFieldProps {
  label: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export function SettingsToggleField({
  label,
  description,
  children,
  className,
}: SettingsToggleFieldProps) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <div className="space-y-0.5">
        <label className="text-sm font-medium leading-none">{label}</label>
        {description && (
          <p className="text-xs text-muted-foreground">{description}</p>
        )}
      </div>
      {children}
    </div>
  );
}
